import { useDispatch } from "react-redux";
import Footer from "../../SharedModule/components/Footer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { RiShareBoxFill } from "react-icons/ri";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  CLIENTS_ACTIVATE_ACCESS,
  CLIENTS_ALL_ROLES,
  HUBSPOT,
  ROUTE_CLIENTS,
  ROUTE_CLIENTS_BILLING_INFO,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
} from "../../SharedModule/utils/constants";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import { useLocation, useNavigate, useParams } from "react-router";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { useEffect } from "react";
import HeaderClientsModule from "../components/HeaderClientsModule";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { useClientBillingInfo } from "../hooks/useClientBillingInfo";
import { checkClientCreatedByCostCenter } from "../utils/clientsUtils";
import { useClientActivationActions } from "../hooks/useClientActivationActions";
import { dateFormatWithHours } from "../../SharedModule/utils/formatters";
import { resetScrollY } from "../../SharedModule/utils/pagesUtils";

export const ClientBillingInfoPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams();

  // If there is no id, go to clients list
  if (!id) {
    navigate(ROUTE_CLIENTS);
  }

  const {
    ClientForHeaderInfo,
    activeUserId,
    clientDetails,
    isBillingInfoLoading,
    actualClientExternalData,
    clientBillingInfo,
    userRolesList,
    rolesLoaded,
    isLoadingWorkInfo,
    clientRecurringBillings,
    clientWorkOrders,
    clientProjects,
  } = useClientBillingInfo(Number(id));

  useEffect(() => {
    document.title = "The Hub - Client Billing Info";

    dispatch(setActiveTab(ROUTE_CLIENTS_BILLING_INFO));

    return () => {
      resetScrollY(globalThis.location.pathname);
    };
  }, []);

  const isExternalClient = () => !!actualClientExternalData;

  const {
    Modal,
    modalProps,
    closeModal,
    deactivateModalPortal,
    isLoadingDeactivate,
    goToEditProfile,
    deactivateClientAction,
    reactivateClientAction,
    checkCouldSeeToggleStatusButton,
    couldSeeEditButton,
    getEditButtonLabel,
  } = useClientActivationActions(
    id,
    ClientForHeaderInfo,
    clientDetails,
    activeUserId,
    userRolesList,
    actualClientExternalData,
    isExternalClient,
    isLoadingWorkInfo,
    clientRecurringBillings,
    clientWorkOrders,
    clientProjects
  );

  return (
    <>
      <Modal closeModal={closeModal} {...modalProps} />
      {deactivateModalPortal}
      <div className="content">
        <HeaderClientsModule
          isLoadingPage={
            isBillingInfoLoading ||
            !rolesLoaded ||
            isLoadingDeactivate ||
            isLoadingWorkInfo
          }
          backFromRelationshipPage={
            location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
          }
        />

        {(isBillingInfoLoading ||
          !rolesLoaded ||
          isLoadingDeactivate ||
          isLoadingWorkInfo) && (
          <Spinner
            style={{
              marginLeft: "50%",
              marginTop: "5%",
            }}
          />
        )}

        {!isBillingInfoLoading &&
          rolesLoaded &&
          !isLoadingWorkInfo &&
          !isLoadingDeactivate &&
          !verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
            <ForbiddenPage />
          )}

        {!isBillingInfoLoading &&
          rolesLoaded &&
          !isLoadingWorkInfo &&
          !isLoadingDeactivate &&
          verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
            <form className="card entry-hour-box-background px-4 py-2 my-3">
              <div
                className="d-flex justify-content-between"
                style={{ margin: "1% 8%" }}
              >
                <h3 style={{ marginTop: "0.5rem" }}>Billing Information</h3>
                {verifyModuleAccess(
                  true,
                  CLIENTS_ACTIVATE_ACCESS,
                  userRolesList
                ) && (
                  <div>
                    {couldSeeEditButton() && ClientForHeaderInfo?.isActive && (
                      <button
                        className="btn button-secondary"
                        type="button"
                        onClick={() => goToEditProfile()}
                      >
                        {getEditButtonLabel()}
                        {(isExternalClient() ||
                          checkClientCreatedByCostCenter(
                            ClientForHeaderInfo.companyName
                          )) && <RiShareBoxFill />}
                      </button>
                    )}
                    {checkCouldSeeToggleStatusButton(
                      ClientForHeaderInfo?.isActive
                    ) && (
                      <button
                        className="btn button-secondary-danger ms-3"
                        type="button"
                        onClick={() => deactivateClientAction()}
                      >
                        Deactivate Client
                      </button>
                    )}
                    {checkCouldSeeToggleStatusButton(
                      !ClientForHeaderInfo?.isActive
                    ) && (
                      <button
                        className="btn button-secondary-danger"
                        type="button"
                        onClick={() => reactivateClientAction()}
                      >
                        Reactivate Client
                      </button>
                    )}
                  </div>
                )}
              </div>

              <div className="row" style={{ margin: "0 8%" }}>
                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label htmlFor="billing-cycle" className="col-form-label">
                      Billing Cycle
                    </label>
                    <input
                      id="billing-cycle"
                      type="text"
                      className="form-control form-control-sm common-input input-no-border"
                      value={clientBillingInfo?.billingCycle}
                      disabled={true}
                    />
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label htmlFor="invoice-format" className="col-form-label">
                      Invoice Format
                    </label>
                    <input
                      id="invoice-format"
                      type="text"
                      className="form-control form-control-sm common-input input-no-border"
                      value={clientBillingInfo?.invoiceFormat}
                      disabled={true}
                    />
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label htmlFor="billing-terms" className="col-form-label">
                      Terms
                    </label>
                    <input
                      id="billing-terms"
                      type="text"
                      className="form-control form-control-sm common-input input-no-border"
                      value={clientBillingInfo?.terms}
                      disabled={true}
                    />
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label htmlFor="billing-taxable" className="col-form-label">
                      Taxable
                    </label>
                    <input
                      id="billing-taxable"
                      type="text"
                      className="form-control form-control-sm common-input input-no-border"
                      value={clientBillingInfo?.taxable ? "Yes" : "No"}
                      disabled={true}
                    />
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label htmlFor="tax-jurisdictions" className="col-form-label">
                      Tax Jurisdictions
                    </label>
                    <input
                      id="tax-jurisdictions"
                      type="text"
                      className="form-control form-control-sm common-input input-no-border"
                      value={clientBillingInfo?.taxJurisdiction}
                      disabled={true}
                    />
                  </div>
                  <div className="flex-column w-50 ms-5"></div>
                </div>

                <div className="d-flex p-0 mb-5">
                  <div className="flex-column w-100">
                    <label
                      htmlFor="accounting-notes"
                      className="col-form-label"
                    >
                      Accounting Notes
                    </label>
                    <TextareaAutosize
                      id="accounting-notes"
                      minRows={1}
                      maxRows={5}
                      className="textarea-resize w-100 d-flex common-input input-no-border"
                      value={clientBillingInfo?.accountingNotes}
                      disabled={true}
                      style={{ height: "100px", resize: "none" }}
                    />
                  </div>
                </div>

                {clientDetails?.lastUpdateDate && (
                  <div className="d-flex p-0 my-3">
                    <label className="helper-title">
                      Last updated by{" "}
                      {clientDetails?.lastUpdateBy === HUBSPOT ||
                      clientDetails?.lastUpdateBy?.length === 0
                        ? HUBSPOT
                        : clientDetails?.lastUpdateBy}{" "}
                      on{" "}
                      {dateFormatWithHours(clientDetails?.lastUpdateDate ?? "")}{" "}
                      (ET) on{" "}
                      {clientDetails?.lastUpdateBy === HUBSPOT
                        ? HUBSPOT
                        : "The Hub"}
                    </label>
                  </div>
                )}
              </div>
            </form>
          )}
        <Footer />
      </div>
    </>
  );
};
